<!--*****************************************************************
  * Copyright (c) Certus Software, 2022.                            *
  *                                                                 *
  * This unpublished material is proprietary to Certus Software.    *
  * All rights reserved. The methods and techniques described       *
  * herein are considered confidential and/or trade secrets.        *
  * Reproduction or distribution, in whole or in part, is forbidden *
  * except by express written permission of Certus Software.        *
  *****************************************************************-->

<div class="guide-pagination">
  <div class="mat-paginator-range-actions">
    <div>
      <a class="mat-paginator-navigation-previous" [routerLink]="previousRoute" aria-describedby="previous-chapter-title">
        <span class="front">
          <i class="arrow-left"></i><span>{{(previousText?.length !== 0 && previousText !== undefined)?previousText:('supportedDevices.previous' | translate)}}</span>
        </span>
      </a>
      <p id="previous-chapter-title" class="small">{{previousChapterText}}</p>
    </div>
  </div>
  <div class="mat-paginator-range-actions">
    <div>
      <a class="mat-paginator-navigation-next" [routerLink]="nextRoute" aria-describedby="next-chapter-title">
        <span class="front">
          <span>{{(nextText?.length !== 0 && nextText !== undefined)?nextText:('supportedDevices.next' | translate)}}</span><i class="arrow-right"></i>
        </span>
      </a>
      <p id="next-chapter-title" class="small">{{nextChapterText}}</p>
    </div>
  </div>
</div>
